import type {
  CarnivalAction,
  CarnivalGameState,
  ValidationResult,
} from "../types";
import { validateRevealSin } from "./reveal-sin";
import { validateSelectSin } from "./select-sin";

export function validateAction(
  state: CarnivalGameState,
  action: CarnivalAction,
): ValidationResult {
  switch (action.type) {
    case "SelectSin":
      return validateSelectSin(state, action);
    case "RevealSin":
      return validateRevealSin(state, action);
  }
}

export * from "./reveal-sin";
export * from "./select-sin";
